<div class="attachment-list pb-2">
  <div class="title mb-3">
      {{ title }}
  </div>

  <div class="border-top pt-1 row m-0 w-100 align-items-center" >
    <button type="button" class="px-2 my-1 bg-gradient-faded"  mat-raised-button (click)="inputFile1.click()" *ngIf="!!!attachments.length" >
        <mat-icon>attach_file</mat-icon>
        <span> Add Attachment</span>
    </button>
    <input hidden mat-raised-button color="default" #inputFile1 (change)="onFileSelected($event)"
    [accept]="accept"  type="file"/>

    <span *ngFor="let attachment of attachments; let item = index;" class="px-2 my-1">
        <button class="position-relative attachment-button" mat-raised-button color="default"
            style="width: 100%; height: 40px; margin-top: 3px" [title]="'Upload Attachment ' + item" type="button">
            <mat-icon>attach_file</mat-icon>
            <ng-container *ngIf="!!attachments[item]">
                <span> {{ attachments[item].filename }}</span>
            </ng-container>
            <span class="bg-danger text-white d-flex align-items-center justify-content-center" (click)="removeAttachment(item)"
            style="position: absolute; transform: rotate(45deg); top:-5px; right:-5px; border-radius: 50%; height:15px; width:15px; cursor:pointer"> + </span>
        </button>
    </span>
    <span class="align-self-center px-2 my-1" style="cursor: pointer" color="default" (click)="inputFile1.click()" *ngIf="!!attachments.length">
      <button mat-stroked-button class="w-100 bg-gradient-faded" type="button">
        <mat-icon color="primary">add</mat-icon>
     </button>
    </span>

  </div>
</div>
